exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".InfoBlock {\n  display: block;\n  width: 100%;\n  padding: 5vh;\n  margin: 5vh 0;\n  font-weight: 200;\n  font-size: 1.2em;\n  text-align: center;\n  font-style: italic;\n  color: #888;\n  background-color: white; }\n  .InfoBlock b {\n    font-weight: 700; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Controllers/InfoBlock/InfoBlock.scss
// module id = 384
// module chunks = 0